import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Image } from 'components/atoms/image';

const AwardsCard = props => {
  const data = props.data;
  const mediaPath = `${data.mediaPath}${data.web}`;
  const thumbnailUrl = `${data.mediaPath}${data.thumbnail}/${props.imagePath}`;
  return (
    <div className="awards_card">
      <Image
        src={`${mediaPath}/${props.imagePath}`}
        thumbNail={thumbnailUrl}
        alt="Award"
        className="award_image"
      />

      <div className="awards_details">
        <Row className="AwardFirstRow">
          <Col md={{ span: 11 }}>
            <span className="award_date">
              {data.awarded_at} /{' '}
              {new Date(data.awarded_on).toString().slice(11, 15)}
            </span>

            <h3 className="award_name">{data.award_name}</h3>
          </Col>
        </Row>
        <Row className="AwardSecondRow">
          <Col md={{ span: 11 }}>
            <span className="authority_title">{data.authority_title}</span>
            <h4 className="awards_authority">{data.authority}</h4>
          </Col>
        </Row>
        {data.isProjectNameVisible &&
          (data.project_name ? (
            <Row>
              <Col md={{ span: 11 }}>
                <span className="awards_project">{data.project}</span>
                <h4 className="awards_project_name">{data.project_name},</h4>
                <h4 className="awards_city_name">{data.city_name}</h4>
              </Col>
            </Row>
          ) : data.award_heading && !data.project_name ? (
            <Row>
              <Col md={{ span: 11 }}>
                <span className="awards_project">{data.award_heading}</span>
                <h4 className="awards_project_name">
                  {data.award_description}
                </h4>
              </Col>
            </Row>
          ) : (
            ''
          ))}
      </div>
    </div>
  );
};
export default AwardsCard;
